import { makeStyles } from 'tss-react/mui';
import React from 'react';
import palette from '@ui/palette';
import PrimaryButton, {
  PrimaryButtonProps,
} from '@ui/Button/legacy/PrimaryButton';

/**
 * @todo we should apply these colors but running into rendering issue
 * with circular loader - figure it makes sense to tag now since this
 * needed to be altered...
 */

interface DestructiveButtonProps extends PrimaryButtonProps {}

const useStyles = makeStyles()(() => ({
  destructive: {
    backgroundColor: palette.punch_300,
    color: palette.gray_1000,
    boxShadow: 'none',
    '&.Mui-focusVisible': {
      backgroundColor: palette.punch_300,
    },
    '&:hover': {
      backgroundColor: '#FFAAC1',
    },
    '&.Mui-disabled, &.Mui-disabled:hover': {
      backgroundColor: palette.punch_300,
      opacity: 0.3,
    },
  },
}));

const DestructiveButton = React.forwardRef<
  HTMLButtonElement,
  DestructiveButtonProps
>(({ children, ...props }, ref) => {
  const { classes } = useStyles();
  return (
    <PrimaryButton
      className={classes.destructive}
      variant="contained"
      {...props}
      ref={ref}
    >
      {children}
    </PrimaryButton>
  );
});

export default DestructiveButton;
